import { createApi } from '@reduxjs/toolkit/query/react';

import apiBaseQuery from './axiosBaseQuery';

export const USERS_API_REDUCER_KEY = 'usersApi';

export const usersApi = createApi({
  reducerPath: USERS_API_REDUCER_KEY,
  baseQuery: apiBaseQuery,
  endpoints: (builder) => ({
    getMe: builder.query({
      query: () => ({
        url: 'users/me/'
      })
    }),
    getUsers: builder.query({
      query: () => ({
        url: 'users/'
      })
    })
  })
});

export const { useGetMeQuery, useGetUsersQuery } = usersApi;